<template lang="pug">
	.dropdown-filter(:class='[state, { selected, "always-show-arrow" : options.alwaysShowArrow }]')
		.icon(@click='toggleOpen')
			.criterion(v-show='selected && !options.alwaysShowArrow')
				.icon-close(@click.stop='clear')
				p {{ selected }}
			.clickable-arrow(v-show='!selected || options.alwaysShowArrow' :class='state')
		.dropdown-body
			.content
				.option(
					v-for='option in selectOptions'
					@click='selectOption( option.text )'
					:class='{ active : selected === option.text }'
				) {{ option.text }}

</template>

<script>
export default {
	name : 'dropdown-filter',

	props : {
		options : {
			required : true,
		},
		openFilter : {
			type : Boolean
		},
	},

	data : () => ( {
		selected      : '',
		state         : '',
		selectOptions : [],
	} ),

	watch : {
		selected( selected ) {
			this.$emit( 'filter', selected );
		},
		state( state ) {
			if ( state === 'open' ) {
				this.$emit( 'open' );
			}
		},
		openFilter( openFilter ) {
			if ( !openFilter ) {
				this.close();
				return;
			}

			this.toggleOpen();
		}
	},

	created() {

		const { options } = this.options;

		if ( typeof options === 'object' || Array.isArray( options ) ) {
			this.selectOptions = options;
			return;
		}

		if ( typeof options === 'function' ) {

			// display a loading text in the dropdown
			const loadingOption = {
				text  : 'Loading Options...',
				value : null,
			};

			this.selectOptions = [loadingOption];

			Promise.resolve()
				.then( () => options() )
				.then( ( value ) => {
					this.selectOptions = value;
				} );
		}

	},

	methods : {

		toggleOpen() {
			const { state } = this;
			this.state = state === 'open' ? 'close' : 'open';
		},

		close() {
			this.state = 'close';
		},

		selectOption( option ) {
			this.selected = option;
			this.state    = 'close';
		},

		clear() {
			this.selected = '';
		},

	},

};
</script>

<style lang="scss">
.dropdown-filter {
	position: relative;
	margin-right: 10px;
	border-radius: 30px;

	&.selected:not(.always-show-arrow) {
		border: 2px solid rgba( $color-primary, 0.25 );
		padding-right: 5px;
	}

	.icon {
		display: flex;
		align-items: center;
		cursor: pointer;
		text-align: center;
	}

	.dropdown-body {
		position: absolute;
		left: 50%;
		top: 100%;
		transform: translate(-49%, -10px);
		border-radius: 10px;
		border-top-right-radius: 0;
		border-top-left-radius: 0;
		background: white;
		box-shadow: $box-shadow__card;
		opacity: 0;
		pointer-events: none;
		transition: opacity 0.2s ease, transform 0.2s ease;
		border-top: 4px solid $color-primary;
		color: $color-secondary;

		* {
			pointer-events: none;
		}

		&::after {
			content: ' ';
			position: absolute;
			top: -4px;
			left: 50%;
			border: 5px solid $color-primary;
			border-bottom: 5px solid transparent;
			border-right: 5px solid transparent;
			transform: translate(-50%,-50%) rotate(45deg);
		}
	}

	.criterion {
		display: flex;
		align-items: center;
		overflow: hidden;
		border-radius: 30px;

		p {
			font-size: 14px;
			margin-left: 10px;
			white-space: nowrap;
		}

		.icon-close {
			height: 25px;
			width: 25px;
			padding-right: 10px;
			background: rgba( $color-primary, 0.25 );

			&::before,
			&::after {
				height: 10px;
				background: $color-primary;
			}
		}
	}

	.content {
		padding: 5px 0;
		max-height: 230px;
		overflow: auto;

		.option {
			padding: 5px 10px;
			color: $color-secondary;
			font-size: 14px;
			min-width: 150px;
			cursor: pointer;

			&.active {
				color: $color-primary;
			}
		}
	}

	&.open {

		.dropdown-body {
			opacity: 1;
			transform: translate(-50%, 10px);
			pointer-events: all;

			* {
				pointer-events: all;
			}
		}
	}
}
</style>
